import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { buildHeaderEntity, getPrivateAreaBaseAPI } from '../../mulesoftService/mulesoft.entity';
import { GetBookingMyMscResponse } from '@msc-b2c/interfaces/interfaces';

export const bookingApi = createApi({
  reducerPath: 'myBooking',
  baseQuery: fetchBaseQuery({
    baseUrl: getPrivateAreaBaseAPI(),
    prepareHeaders: (headers) => {
      const headersEntity = buildHeaderEntity(true);
      const entityHeaders = headersEntity.toHeaders();
      Object.entries(entityHeaders).forEach(([key, value]) => {
        headers.set(key, value as string);
      });
      return headers;
    },
  }),
  tagTypes: ['Booking'],
  endpoints: (builder) => ({
    getBooking: builder.query<GetBookingMyMscResponse, string>({
      query: (id) => `/bookings/${id}`,
      providesTags: ['Booking'],
    }),
  }),
});

export const { useGetBookingQuery, useLazyGetBookingQuery } = bookingApi;
